import * as React from "react";
import Component from "../../AbstractComponent";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import CompanyCreateWillMount from "../../../Middleware/Middlewares/CompanyCreateWillMount";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { Attachment } from "../../Partials/Attachment/Attachment";
import * as uuidV4 from "uuid/v4";

class CompanyCreate extends Component {
  public state = {
    name: "",
    email: "",
    phone: "",
    mainBankAccountId: "",
    mainBankAccountName: "",
    companyBankId: "",
    amazonFolderName: uuidV4(),
    openLeavePrompt: false,
    note: "",
    hasModifiedData: false,
    isSaving: false,
    ibanUsedForEntity: null,
    address: {
      formattedAddress: ""
    },
    attachments: [],
    companyRegistry: "",
    vat: ""
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    CompanyCreateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);

    this.save = this.save.bind(this);
  }

  public save() {
    const iban = this.state.mainBankAccountId;

    if (iban) {
      const company: CompanyInterface = this.props.app.companies.filter(company => !company.removed).find((company: CompanyInterface) => company.mainBankAccountId === this.state.mainBankAccountId);
      const person: PersonInterface = this.props.app.persons.filter(person => !person.removed).find((person: PersonInterface) => person.mainBankAccountId === this.state.mainBankAccountId);

      if (!!person ) {
        this.setState({
          ibanUsedForEntity: person
        });
      }

      if (!!company ) {
        this.setState({
          ibanUsedForEntity: company
        });
      }
    }

    this.saving(() => {
      let pageTemplate = "company";

      if (this.props.location.pathname.includes("owner")) {
        pageTemplate = "owner";
      }

      this.props.dispatch({
        type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
        payload: {
          company: {
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            mainBankAccountId: this.state.mainBankAccountId,
            mainBankAccountName: this.state.mainBankAccountName,
            bankAccount: {
              accountId: this.state.mainBankAccountId,
              name: this.state.mainBankAccountName
            },
            companyBankId: this.state.companyBankId,
            address: Object.keys(this.state.address || {}).length > 0 ? { ...this.state.address } : null,
            amazonFolderName: this.state.amazonFolderName,
            note: this.state.note,
            pageTemplate: pageTemplate,
            companyRegistry: this.state.companyRegistry,
            vat: this.state.vat
          }
        },
        onSuccess: company => {
          const savedDataBeforeRedirecting = {...this.props.app.savedDataBeforeRedirecting};

          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          savedDataBeforeRedirecting.createdCompany = company;
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
            payload: {
              savedDataBeforeRedirecting: {...savedDataBeforeRedirecting}
            }
          });

          this.redirectBack();
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public getTitle = () => {
    if (this.props.location.pathname.includes("owner")) {
      return this.trans("title-new-owner");
    }

    return this.trans("title-new-company");
  }

  public getNameField = () => {
    if (this.props.location.pathname.includes("owner")) {
      return this.trans("label-owner-name");
    }

    return this.trans("label-company-name");
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.getTitle()}</h1>
              <div className="button-container">
                <Button
                  color="primary"
                  onClick={this.cancel.bind(this)}
                  style={{marginRight: "20px"}}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.save}
                  disabled={this.state.isSaving}
                >
                  {this.state.isSaving === true ? this.trans("button-saving") : this.trans("button-create")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-company-create">
            <div className="component-wrapper no-margin-top">
              <div className="component">
                <Card className="card">
                  <div style={{maxWidth: "420px", padding: "10px 40px 10px 10px"}}>
                    <form>
                      {
                        this.props.location.pathname.includes("owner") && (
                          <div style={{color: "gray", fontSize: "14px", margin: "25px 0 px 0"}}>{this.trans("page/companycreate-companyname-info")}</div>
                        )
                      }
                    
                      <TextField
                        autoComplete="off"
                        //id="name"
                        // name="name"
                        className="form-element full-size scroll-to-name"
                        type="text"
                        label={this.getNameField()}
                        value={this.state.name}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "name")}
                        autoFocus={true}
                        variant="standard"
                        error={!!this.getErrorFor("name")}
                        helperText={this.getErrorFor("name")}
                      />

                      <AddressSelector
                        {...this.props}
                        id="address"
                        name="address.googlePlaceId"
                        className="scroll-to-address"
                        isInlineBlock={true}
                        width="100%"
                        containerWidth="100%"
                        searchText={this.state.address.formattedAddress ? this.state.address.formattedAddress : null}
                        selectedAddress={this.state.address}
                        onSelect={this.sync.bind(this, this.syncronizers.VALUE, "address")}
                        onClear={this.sync.bind(this, this.syncronizers.VALUE, "address", {})}
                      />

                      {/* <TextField
                        autoComplete="off"
                        // id="email"
                        // name="email"
                        className="form-element full-size scroll-to-email"
                        type="text"
                        label={this.trans("label-email") + this.trans("field/optional")}
                        value={this.state.email}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
                        variant="standard"
                        error={!!this.getErrorFor("email")}
                        helperText={this.getErrorFor("email")}
                      /> */}

                      <TextField
                        autoComplete="off"
                        //  id="phone"
                        // name="phone"
                        className="form-element full-size scroll-to-phone"
                        type="text"
                        label={this.trans("phone") + this.trans("field/optional")}
                        value={this.state.phone}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone")}
                        variant="standard"
                        error={!!this.getErrorFor("phone")}
                        helperText={this.getErrorFor("phone")}
                      />

                      <TextField
                        autoComplete="off"
                        // id="bankAccountId"
                        // name="bankAccountId"
                        className="form-element full-size scroll-to-mainBankAccountId"
                        type="text"
                        label={this.trans("label-bank-account-id") + this.trans("field/optional")}
                        value={this.state.mainBankAccountId}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountId")}
                        variant="standard"
                        error={!!this.getErrorFor("createData.bankAccount.accountId")}
                        helperText={this.getErrorFor("createData.bankAccount.accountId")}
                      />

                      <TextField
                        autoComplete="off"
                        // id="mainBankAccountName"
                        // name="mainBankAccountName"
                        className="form-element full-size scroll-to-mainBankAccountName"
                        type="text"
                        label={this.trans("label-bank-account-name") + this.trans("field/optional")}
                        value={this.state.mainBankAccountName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountName")}
                        variant="standard"
                        error={!!this.getErrorFor("mainBankAccountName")}
                        helperText={this.getErrorFor("mainBankAccountName")}
                      />

                      <TextField
                        autoComplete="off"
                        id="companyRegistry"
                        name="companyRegistry"
                        className="form-element full-size scroll-to-companyRegistry"
                        type="text"
                        label={this.trans("label-company-registry") + this.trans("field/optional")}
                        value={this.state.companyRegistry}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyRegistry")}
                        inputProps={{ maxLength: 255 }}
                        variant="standard"
                        error={!!this.getErrorFor("companyRegistry")}
                        helperText={this.getErrorFor("companyRegistry")}
                      />

                      <TextField
                        autoComplete="off"
                        // id="vat"
                        // name="vat"
                        className="form-element full-size scroll-to-vat"
                        type="text"
                        label={this.trans("label-vat-number") + this.trans("field/optional")}
                        value={this.state.vat}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "vat")}
                        variant="standard"
                        error={!!this.getErrorFor("vat")}
                        helperText={this.getErrorFor("vat")}
                      />        

                      <TextField
                        autoComplete="off"
                        // id="note"
                        // name="note"
                        className="form-element full-size scroll-to-note"
                        type="text"
                        multiline={true}
                        rowsMax={10}
                        label={this.trans("note") + this.trans("field/optional")}
                        value={this.state.note}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                        variant="standard"
                        error={!!this.getErrorFor("note")}
                        helperText={this.getErrorFor("note")}
                      />
                    </form>
                  </div>
                </Card>
              </div>
            </div>

            <div className="component-wrapper">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                possibilityToSetAvatar={true}
                title={this.props.location.pathname.includes("owner") ? this.trans("attachments-for-owner") : this.trans("attachments-for-company")}
                relation="companyId"
                onAmazonFolderNameGeneration={!this.state.amazonFolderName ?
                  this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
                amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
                attachments={this.state.attachments}
                updateParentState={attachments => this.setState({attachments: attachments})}
                onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
              />
            </div>
          </div>
        </div>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.companyCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  CompanyCreate
);
